<mat-toolbar color="primary" role="banner">
  <mat-toolbar-row>
    <a class="skip-to-content-link bg_color_primary" [href]="util.skipLinkPath">Skip to main content</a>
    <button *ngIf="sidebarService.enabled" mat-icon-button (click)="onToggleDrawer()" aria-label="Menu Open/Close">
      <mat-icon>menu</mat-icon>
    </button>
    <img src="assets/img/US_GAO_logo.png" height="36" alt="GAO logo">

    <div fxFlex fxLayout fxLayoutAlign="flex-end">
      <button mat-button [matMenuTriggerFor]="helpMenu" #helpMenuTrigger>Help<mat-icon iconPositionEnd>more_vert</mat-icon></button>
      <mat-menu #helpMenu="matMenu">
        <button mat-menu-item (click)="onUserGuide()" aria-label="Opens user guide">User Guide</button>
        <button mat-menu-item (click)="onBestPractice()" aria-label="Opens best practices">Best Practices</button>
        <button mat-menu-item (click)="onInstructions()" aria-label="Opens instructions">Instructions</button>
        <button mat-menu-item (click)="onFAQ()" aria-label="Opens FAQ">FAQ</button>
        <button mat-menu-item (click)="onContactUs()" aria-label="Opens contact us dialog">Contact Us</button>
        <button mat-menu-item (click)="onFeedback()" aria-label="Opens feedback dialog">Feedback</button>
      </mat-menu>

      <button mat-button *ngIf="stateService.isLoggedIn" [matMenuTriggerFor]="userMenu" #userMenuTrigger>{{stateService.user.first_Name}} {{stateService.user.last_Name}}</button>
      <mat-menu #userMenu="matMenu">
        <button mat-menu-item (click)="onManageUserProfile()" aria-label="Opens user profile page">Manage User Profile</button>
        <button mat-menu-item (click)="onLogout()" aria-label="Opens logout confirmation dialog">Logout</button>
      </mat-menu>
    </div>

  </mat-toolbar-row>
</mat-toolbar>
